import { AnimatePresence, motion } from "framer-motion";
import { classNames } from "../../helpers/classNames";
import { useState } from "react";

export default function Accordion({
  buttonClass,
  contentClass,
  data = [],
  className,
  bodyClass,
  wrapperClass,
}) {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleItem = (i) => {
    if (i === 0) {
      setOpenIndex(0);
    } else {
      setOpenIndex(openIndex === i ? null : i);
    }
  };

  return (
    <div className={classNames("w-full", className)}>
      <div
        className={classNames(
          "mx-auto w-full rounded-2xl bg-white space-y-2",
          bodyClass
        )}
      >
        {Array.isArray(data) &&
          data.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className={classNames("w-full", wrapperClass)}>
                {/* Button */}
                <button
                  onClick={() => toggleItem(i)}
                  className={classNames(
                    "flex w-full justify-between items-center rounded-lg bg-primary/10 px-4 py-2 text-left text-sm font-medium hover:bg-primary/30 transition-all duration-150",
                    buttonClass,
                    item.buttonClass
                  )}
                >
                  <span>{item?.title}</span>
                  <i
                    className={classNames(
                      "ml-auto transition-transform duration-300",
                      isOpen ? "fa-light fa-minus" : "fa-light fa-plus"
                    )}
                  ></i>
                </button>

                {/* Content */}
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <div
                        className={classNames(
                          "px-4 pb-2 pt-4 text-sm",
                          contentClass,
                          item.contentClass
                        )}
                      >
                        {item?.content}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
      </div>
    </div>
  );
}